// import React, { useState, useEffect } from 'react';
// import Swal from 'sweetalert2';
// import { connect } from 'react-redux';
// import { setBreadcrumbItems } from "../../store/actions";
// import * as XLSX from 'xlsx'; // <--- IMPORTANTE

// const Pagos = (props) => {
//   document.title = "Socios  | Pagos - Ges Sindical";

//   const breadcrumbItems = [
//     { title: "Socios", link: "#" },
//     { title: "Pagos", link: "#" },
//   ];

//   useEffect(() => {
//     props.setBreadcrumbItems('Pagos', breadcrumbItems);
//   }, []);

//   const [pagos, setPagos] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [mes, setMes] = useState(new Date().getMonth() + 1);
//   const [anio, setAnio] = useState(new Date().getFullYear());
//   const [total, setTotal] = useState(0);
//   const [metodosPago, setMetodosPago] = useState([]);
//   const [recaudacionPorMetodo, setRecaudacionPorMetodo] = useState([]);

//   // Cargar métodos de pago
//   useEffect(() => {
//     fetch('https://asijeminapis.website:5248/api/payment-methods')
//       .then(res => res.json())
//       .then(data => setMetodosPago(Array.isArray(data) ? data : []));
//   }, []);

//   // Consultar pagos por mes/año
//   const fetchPagos = () => {
//     setLoading(true);
//     fetch(`https://asijeminapis.website:5248/api/payments?year=${anio}&month=${mes}`)
//       .then(res => res.json())
//       .then(data => {
//         setPagos(Array.isArray(data) ? data : []);
//         setLoading(false);
//         // Calcular total recaudado
//         const totalRec = data.reduce((acc, p) => acc + (p.amount || 0), 0);
//         setTotal(totalRec);
//       })
//       .catch(() => setLoading(false));
//   };

//   // Consultar recaudación por método
//   const fetchRecaudacionPorMetodo = () => {
//     fetch(`https://asijeminapis.website:5248/api/payments/revenue-by-method?year=${anio}&month=${mes}`)
//       .then(res => res.json())
//       .then(data => {
//         setRecaudacionPorMetodo(Array.isArray(data) ? data : []);
//       });
//   };

//   useEffect(() => {
//     fetchPagos();
//     fetchRecaudacionPorMetodo();
//     // eslint-disable-next-line
//   }, [mes, anio]);

//   const meses = [
//     'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
//     'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
//   ];

//   // ---- Descarga como Excel (.xlsx) ----
//   const descargarExcel = () => {
//     // Armamos los datos
//     const filas = pagos.map(p => ({
//       Socio: p.memberId?.name || '',
//       Documento: p.memberId?.documento || '',
//       Monto: p.amount,
//       Método: p.paymentMethod?.name || p.paymentMethod || '',
//       Fecha: new Date(p.paymentDate).toLocaleDateString()
//     }));

//     // Crea hoja y archivo
//     const ws = XLSX.utils.json_to_sheet(filas);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Pagos");

//     // Exportar archivo
//     XLSX.writeFile(wb, `pagos_${anio}_${mes}.xlsx`);
//   };

//   return (
//     <div className="container mt-4">
//       <h2>Pagos Realizados</h2>

//       <div className="row mb-3">
//         <div className="col-md-3">
//           <label>Mes:</label>
//           <select className="form-control" value={mes} onChange={e => setMes(Number(e.target.value))}>
//             {meses.map((m, idx) => (
//               <option key={idx} value={idx + 1}>{m}</option>
//             ))}
//           </select>
//         </div>
//         <div className="col-md-3">
//           <label>Año:</label>
//           <input
//             type="number"
//             className="form-control"
//             value={anio}
//             min={2020}
//             max={2050}
//             onChange={e => setAnio(Number(e.target.value))}
//           />
//         </div>
//         <div className="col-md-3 d-flex align-items-end">
//           <button className="btn btn-primary w-100" onClick={fetchPagos} disabled={loading}>
//             Buscar
//           </button>
//         </div>
//         <div className="col-md-3 d-flex align-items-end">
//           <button className="btn btn-success w-100" onClick={descargarExcel}>
//             Descargar Excel
//           </button>
//         </div>
//       </div>

//       <div className="mb-3">
//         <h5>Total recaudado: <span className="text-success">${total}</span></h5>
//         <h6>Recaudación por Método:</h6>
//         <ul>
//           {recaudacionPorMetodo.map(r => (
//             <li key={r.metodo}>{r.metodo}: <b>${r.total}</b></li>
//           ))}
//           {recaudacionPorMetodo.length === 0 && <li>Sin datos</li>}
//         </ul>
//       </div>

//       {loading ? <p>Cargando...</p> : (
//         <table className="table table-bordered">
//           <thead>
//             <tr>
//               <th>Socio</th>
//               <th>Documento</th>
//               <th>Monto</th>
//               <th>Método</th>
//               <th>Fecha</th>
//             </tr>
//           </thead>
//           <tbody>
//             {pagos.map((p, i) => (
//               <tr key={i}>
//                 <td>{p.memberId?.name || ''}</td>
//                 <td>{p.memberId?.documento || ''}</td>
//                 <td>${p.amount}</td>
//                 <td>{p.paymentMethod?.name || p.paymentMethod || ''}</td>
//                 <td>{new Date(p.paymentDate).toLocaleDateString()}</td>
//               </tr>
//             ))}
//             {pagos.length === 0 && (
//               <tr><td colSpan={5} className="text-center">No hay pagos registrados.</td></tr>
//             )}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// };

// export default connect(null, { setBreadcrumbItems })(Pagos);




import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from "../../store/actions";
import * as XLSX from 'xlsx';

const Pagos = (props) => {
  document.title = "Socios  | Pagos - Ges Sindical";

  const breadcrumbItems = [
    { title: "Socios", link: "#" },
    { title: "Pagos", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems('Pagos', breadcrumbItems);
  }, []);

  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [total, setTotal] = useState(0);
  const [metodosPago, setMetodosPago] = useState([]);
  const [recaudacionPorMetodo, setRecaudacionPorMetodo] = useState([]);
  const [filtro, setFiltro] = useState(''); // Nuevo estado para búsqueda

  // Cargar métodos de pago
  useEffect(() => {
    fetch('https://asijeminapis.website:5248/api/payment-methods')
      .then(res => res.json())
      .then(data => setMetodosPago(Array.isArray(data) ? data : []));
  }, []);

  // Consultar pagos por mes/año
  const fetchPagos = () => {
    setLoading(true);
    fetch(`https://asijeminapis.website:5248/api/payments?year=${anio}&month=${mes}`)
      .then(res => res.json())
      .then(data => {
        setPagos(Array.isArray(data) ? data : []);
        setLoading(false);
        // Calcular total recaudado
        const totalRec = data.reduce((acc, p) => acc + (p.amount || 0), 0);
        setTotal(totalRec);
      })
      .catch(() => setLoading(false));
  };

  // Consultar recaudación por método
  const fetchRecaudacionPorMetodo = () => {
    fetch(`https://asijeminapis.website:5248/api/payments/revenue-by-method?year=${anio}&month=${mes}`)
      .then(res => res.json())
      .then(data => {
        setRecaudacionPorMetodo(Array.isArray(data) ? data : []);
      });
  };

  useEffect(() => {
    fetchPagos();
    fetchRecaudacionPorMetodo();
    // eslint-disable-next-line
  }, [mes, anio]);

  const meses = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  // Descarga como Excel (.xlsx)
  const descargarExcel = () => {
    const filas = pagosFiltrados.map(p => ({
      Socio: p.memberId?.name || '',
      Documento: p.memberId?.documento || '',
      Monto: p.amount,
      Método: p.paymentMethod?.name || p.paymentMethod || '',
      Fecha: new Date(p.paymentDate).toLocaleDateString()
    }));

    const ws = XLSX.utils.json_to_sheet(filas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Pagos");

    XLSX.writeFile(wb, `pagos_${anio}_${mes}.xlsx`);
  };

  // FILTRO por nombre o documento (insensible a mayúsculas/minúsculas)
  const pagosFiltrados = pagos.filter(p => {
    const filtroLower = filtro.trim().toLowerCase();
    if (filtroLower === '') return true;
    const nombre = (p.memberId?.name || '').toLowerCase();
    const documento = (p.memberId?.documento || '').toLowerCase();
    return nombre.includes(filtroLower) || documento.includes(filtroLower);
  });

  return (
    <div className="container mt-4">
      <h2>Pagos Realizados</h2>

      <div className="row mb-3">
        <div className="col-md-3">
          <label>Mes:</label>
          <select className="form-control" value={mes} onChange={e => setMes(Number(e.target.value))}>
            {meses.map((m, idx) => (
              <option key={idx} value={idx + 1}>{m}</option>
            ))}
          </select>
        </div>
        <div className="col-md-3">
          <label>Año:</label>
          <input
            type="number"
            className="form-control"
            value={anio}
            min={2020}
            max={2050}
            onChange={e => setAnio(Number(e.target.value))}
          />
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button className="btn btn-primary w-100" onClick={fetchPagos} disabled={loading}>
            Buscar
          </button>
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button className="btn btn-success w-100" onClick={descargarExcel}>
            Descargar Excel
          </button>
        </div>
      </div>

      {/* Campo de búsqueda */}
      <div className="row mb-3">
        <div className="col-md-4">
          <input
            type="text"
            className="form-control"
            placeholder="Buscar por nombre o documento..."
            value={filtro}
            onChange={e => setFiltro(e.target.value)}
          />
        </div>
      </div>

      <div className="mb-3">
        <h5>Total recaudado: <span className="text-success">${total}</span></h5>
        <h6>Recaudación por Método:</h6>
        <ul>
          {recaudacionPorMetodo.map(r => (
            <li key={r.metodo}>{r.metodo}: <b>${r.total}</b></li>
          ))}
          {recaudacionPorMetodo.length === 0 && <li>Sin datos</li>}
        </ul>
      </div>

      {loading ? <p>Cargando...</p> : (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Socio</th>
              <th>Documento</th>
              <th>Monto</th>
              <th>Método</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            {pagosFiltrados.map((p, i) => (
              <tr key={i}>
                <td>{p.memberId?.name || ''}</td>
                <td>{p.memberId?.documento || ''}</td>
                <td>${p.amount}</td>
                <td>{p.paymentMethod?.name || p.paymentMethod || ''}</td>
                <td>{new Date(p.paymentDate).toLocaleDateString()}</td>
              </tr>
            ))}
            {pagosFiltrados.length === 0 && (
              <tr><td colSpan={5} className="text-center">No hay pagos registrados.</td></tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(Pagos);
